export default "__VITE_ASSET__BiQhYbXf__"